import React from "react"
import PropTypes from "prop-types"
import { Box, Typography } from "@mui/material"

const CompanyMetadataContext = ({ ariaLabel, fields }) => (
    <Box
        component="section"
        aria-label={ariaLabel}
        sx={{
            display: "grid",
            gridTemplateColumns: { xxxs: "repeat(2, minmax(0, 1fr))", md: `repeat(${fields.length}, minmax(0, 1fr))` },
            columnGap: { xxxs: 3, md: 4 },
            rowGap: { xxxs: 2.5, md: 0 },
            minWidth: 0,
            width: "100%",
        }}
    >
        {fields.map(({ label, value }) => (
            <Box
                key={label}
                sx={{
                    minWidth: 0,
                    px: 2,
                    py: 0.25,
                    borderLeft: (theme) => `1px solid ${theme.palette.input.background.white30}`,
                }}
            >
                <Typography
                    component="div"
                    variant="contraHeading"
                    sx={{ color: (theme) => theme.palette.primary.white70, display: "block", fontSize: "10px", lineHeight: "12px", whiteSpace: "nowrap" }}
                >
                    {label}
                </Typography>
                <Typography
                    component="div"
                    variant="textBody"
                    color="common.white"
                    sx={{ display: "block", fontWeight: 400, mt: 0.75, overflowWrap: "anywhere", wordBreak: "break-word" }}
                >
                    {value ?? "-"}
                </Typography>
            </Box>
        ))}
    </Box>
)

CompanyMetadataContext.propTypes = {
    ariaLabel: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })).isRequired,
}

export default CompanyMetadataContext
